import(/* webpackMode: "eager", webpackExports: ["DealsContext"] */ "/vercel/path0/src/app/hottest-deals/components/Deals/DealsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Deals"] */ "/vercel/path0/src/app/hottest-deals/components/Deals/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DealsFAQ"] */ "/vercel/path0/src/app/hottest-deals/components/DealsFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DealsFilters"] */ "/vercel/path0/src/app/hottest-deals/components/DealsFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CKEditor"] */ "/vercel/path0/src/components/CKEditor/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/css/modules/HottestDeals.module.scss");
